export function truncateFilter(input: string, length: number): string {

    if(input === null){
        return null;
    }

    const suffix = '...';

    if(input.length <= length){
        return input;
    }

    return input.substring(0, length) + suffix;
}